<mg-table [collectionComponent]="this" matSort stickyHeaders>

    <ng-container matColumnDef="artikel">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Artikel </th>
        <td mat-cell *matCellDef="let row"> {{row.artikel?.omschrijving1}} </td>
    </ng-container>

	<ng-container matColumnDef="aantal">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Aantal </th>
        <td mat-cell *matCellDef="let row"> {{row.aantal?.toFixed(2)}} </td>
    </ng-container>

	<ng-container matColumnDef="aantal_Offerte">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Offerte </th>
        <td mat-cell *matCellDef="let row"> {{row.aantal_Offerte?.toFixed(2)}} </td>
    </ng-container>

	<ng-container matColumnDef="aantal_Besteld">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Besteld </th>
        <td mat-cell *matCellDef="let row"> {{row.aantal_Besteld?.toFixed(2)}} </td>
    </ng-container>

	<ng-container matColumnDef="aantal_Geleverd">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Geleverd </th>
        <td mat-cell *matCellDef="let row"> {{row.aantal_Geleverd?.toFixed(2)}} </td>
    </ng-container>

	<ng-container matColumnDef="prijs">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Prijs </th>
        <td mat-cell *matCellDef="let row"> € {{row.prijs?.toFixed(2)}} </td>
    </ng-container>

</mg-table>
